import { Link } from 'tools/Link'
import { Icon } from 'tools/Uniform'

import { pathTo } from 'libreon/routes'

export function WarnBar({ children, base = 'base-warn' }) {
  return <div className={`${base} tc f1 flex-center gh2`}>{children}</div>
}

export function BetaBar({ children }) {
  return (
    <WarnBar base="bg-info ba">
      Libreon is still in development. PLEASE{' '}
      <Link to="/c/chat" className="neutral">
        reach out on chat
      </Link>{' '}
      if you experience any problems.
    </WarnBar>
  )
}

export function UpdateBar() {
  if (window.VERSION_OUTDATED) {
    return (
      <WarnBar>
        There is a new version of Libreon. Please refresh your browser window:
        <button onClick={() => window.location.reload()} className="button clear">
          Reload
        </button>
      </WarnBar>
    )
  }
  return null
}

export function VerifiedBar() {
  return (
    <WarnBar>
      Functionality will be limited until you verify your email.
      <Link to="/u/_/contact">Resend Verification</Link>
    </WarnBar>
  )
}

export function AuthLock() {
  return (
    <span className="f1">
      <Icon type="lock" />
    </span>
  )
}

export function PublicPreview() {
  return (
    <WarnBar>
      PUBLIC PREVIEW — <Link to={pathTo('auth_signon')}>sign in</Link> to use all
      features
    </WarnBar>
  )
}
